export const IN_HOUSE_REPORTS_LIMIT = 12;
export const DELIVER_IN_HOUSE_REPORT_ENDPOINT =
  "/leads/send-inhouse-report-to-admin/";

export const isInHouseReport = (report = {}) => {
  // const reportType = String(report?.report_type || report?.type || "").toLowerCase();

  return (
    // reportType === "inhouse" ||
    // reportType === "in-house" ||
    // Boolean(report?.is_inhouse_report) ||
    // Boolean(report?.is_inhouse) ||
    Boolean(report?.inhouse_last_reminder_sent_at) ||
    Boolean(report?.inhouse_pending_deadline_at) ||
    Boolean(report?.inhouse_work_deadline_at)
  );
};

export const navRedirect = (url = '', report = {}) => {
  const reportIsInHouse = isInHouseReport(report);
  if (reportIsInHouse) url += `&admin_inhouse=true`;
  return url;
}

export const deliverInHouseReportToAdmin = (apiClient, reportId) =>
  apiClient.post(DELIVER_IN_HOUSE_REPORT_ENDPOINT, { report_id: reportId });

export const normalizeInHouseReportsResponse = (payload) => {
  if (Array.isArray(payload)) {
    return { results: payload, count: payload.length };
  }

  if (Array.isArray(payload?.results)) {
    return {
      results: payload.results,
      count: Number(payload?.count ?? payload.results.length),
    };
  }

  if (Array.isArray(payload?.data)) {
    return {
      results: payload.data,
      count: Number(payload?.count ?? payload.data.length),
    };
  }

  return { results: [], count: 0 };
};

export const fetchAgentInHouseReports = async ({
  apiClient,
  agentId,
  page = 1,
  limit = IN_HOUSE_REPORTS_LIMIT,
}) => {
  const response = await apiClient.get("/leads/report/search", {
    params: {
      page,
      limit,
      agent_id: agentId,
      ordering: "-date_created",
      report_type: "inhouse",
    },
  });

  return normalizeInHouseReportsResponse(response?.data);
};

export const getInHouseNotificationCandidates = (reports = []) =>
  reports.filter((report) => report?.status === "PendingAssignment");

export const getInHouseReportFingerprint = (report = {}) =>
  [
    report?.id,
    report?.status,
    report?.date_updated ??
    report?.updated_at ??
    report?.updated ??
    report?.modified ??
    report?.date_created,
    report?.agent?.id ?? report?.assigned_agent?.id ?? "",
  ].join(":");

export const getInHouseNotificationPreference = (payload) => {
  if (typeof payload?.report_notification === "boolean") {
    return payload.report_notification;
  }

  if (typeof payload?.data?.report_notification === "boolean") {
    return payload.data.report_notification;
  }

  if (typeof payload?.results?.report_notification === "boolean") {
    return payload.results.report_notification;
  }

  return null;
};
